import { signalConfig } from '../data/mockData';
export default function SignalBar({ score, signal }) {
  const c = signalConfig[signal] || signalConfig.good;
  return (
    <div>
      <div className="flex justify-between text-xs mb-1.5">
        <span className={c.text}>{c.label}</span>
        <span className="text-gray-500 font-mono text-[11px]">{Math.round(score*100)}%</span>
      </div>
      <div className="h-1.5 bg-zinc-800 rounded-full overflow-hidden">
        <div className={`h-full rounded-full transition-all duration-700`} style={{width:`${score*100}%`, background:c.color}} />
      </div>
    </div>
  );
}
